import { render, staticRenderFns } from "./ChoiceContentBlockForm.vue?vue&type=template&id=3f88b224&"
import script from "./ChoiceContentBlockForm.vue?vue&type=script&lang=ts&"
export * from "./ChoiceContentBlockForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports